const config = {
  metropolis: 'metropolisTheme',
  sportapp: 'sportappTheme',
  patrick: 'patrickTheme',
  'buetzer-buebe': 'buetzerBuebeTheme'
};

export default config;



// WEBPACK FOOTER //
// ./src/themeConfig.js